import React from 'react'
import PropTypes from 'prop-types'
import notify from '../../../../utilities/notify'
export default function DestroyTicketButton ({ onClick, ticket }) {
  const { id, status, invoiceId, invoice } = ticket
  return (
    <button
      className='dis-btn dis-btn-blank dis-btn-sm'
      onClick={() => {
        if (status === 'en_route') {
          notify('error', 'En Route Tickets cannot be destroyed. Please complete or cancel the En Route Ticket prior to deleting it.', 4)
        } else if (invoiceId !== null && invoice?.dispatcherInvoiceNumber) {
          notify('error', `Invoiced Tickets cannot be destroyed. Please remove the Ticket from Invoice #${invoice.dispatcherInvoiceNumber} prior to deleting it.`, 4)
        } else {
          const result = window.confirm(
            'THIS CANNOT BE UNDONE! Deleting a ticket will remove any record ' +
          'that it existed including its images.')
          if (result) {
            onClick(id)
          }
        }
      }}>
      Destroy Ticket
      <i className='material-icons dis-btn-icon'>delete</i>
    </button>
  )
}

DestroyTicketButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string,
    invoiceId: PropTypes.string,
    invoice: PropTypes.object
  }).isRequired
}
